/** Тип Гб пресета */
export const GB_TYPES = 'Gbytes';
